// What the cards share: their props. The document cards add documentProperty and useDocumentType()
// (@/js/properties).
export const cardProps = {
  target: {
    type: String,
    default: undefined,
  },

  highlighted: {
    type: Boolean,
    default: false,
  },
};
